import React from 'react';
import PhoneInputField from '../../../BuildingBlocks/Form/PhoneInputField';

export default function PhoneNumberField({ setValue, errors, register }) {
  return (
    <PhoneInputField
      errors={errors}
      label={'Phone number'}
      name={'phoneNumber'}
      setValue={setValue}
      TextFieldProps={{
        ...register('phoneNumber'),
      }}
    />
  );
}
